import React, { FC, useCallback } from 'react';

import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import withErrorBoundary from 'HOC/ErrorBoundary';

const overrideStyles = { color: '#079DC0' };

interface Props {
  callback?: (e: any) => void;
  applied?: any;
}

const AppliedToMyInstitution: FC<Props> = (props: Props) => {
  const { callback, applied } = props;

  return (
    <>
      <FilterRadioHidden
        label="Any"
        value="Any"
        overrideStyles={overrideStyles}
        selected={applied === 'Any'}
        identifier="applied"
        onClick={useCallback(callback, [applied])}
      />
      <FilterRadioHidden
        label="Yes"
        value="Yes"
        overrideStyles={overrideStyles}
        selected={applied === 'Yes'}
        identifier="applied"
        onClick={useCallback(callback, [applied])}
      />
      <FilterRadioHidden
        label="No"
        value="No"
        overrideStyles={overrideStyles}
        selected={applied === 'No'}
        identifier="applied"
        onClick={useCallback(callback, [applied])}
      />
    </>
  );
};

AppliedToMyInstitution.defaultProps = {
  callback: () => {},
  applied: 'No',
};

export default withErrorBoundary(AppliedToMyInstitution);
